import { render, staticRenderFns } from "./visualizarLibro.vue?vue&type=template&id=273a96ee&scoped=true"
import script from "./visualizarLibro.vue?vue&type=script&lang=js"
export * from "./visualizarLibro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a96ee",
  null
  
)

export default component.exports